import React from 'react';
import { Box, IconButton } from '@mui/material';

import DropdownSelect from '../../../components/DropdownSelect';
import Icons from '../../../components/icons';
import TextInputWithIcon from '../../../components/TextInputWithIcon';
import { ScoringType } from '../types';

export interface MarkBookSectionRowProps {
  firstFieldLabel: string;
  firstFieldValue: string;
  scoringTypeValue: string;
  maxMarksValue: string;
  orderValue: string;
  scoringTypeOptions: ScoringType[];
  isLoadingScoringTypes: boolean;
  onFirstFieldChange: (value: string) => void;
  onScoringTypeChange: (value: string) => void;
  onMaxMarksChange: (value: string) => void;
  onOrderChange: (value: string) => void;
  onDeleteRequest: () => void;
}

const MarkBookSectionRow: React.FC<MarkBookSectionRowProps> = ({
  firstFieldLabel,
  firstFieldValue,
  scoringTypeValue,
  maxMarksValue,
  orderValue,
  scoringTypeOptions,
  isLoadingScoringTypes,
  onFirstFieldChange,
  onScoringTypeChange,
  onMaxMarksChange,
  onOrderChange,
  onDeleteRequest
}) => {
  const selectedScoringType = scoringTypeOptions.find(
    (st) => st.id === scoringTypeValue
  );
  const needsMaxMarks =
    !!scoringTypeValue &&
    (!selectedScoringType?.validScores ||
      selectedScoringType.validScores.length === 0);

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <TextInputWithIcon
          label={firstFieldLabel}
          placeholder={`Enter ${firstFieldLabel}`}
          value={firstFieldValue}
          onChange={(e) => onFirstFieldChange(e.target.value)}
          hasTopLabel={false}
          required
          fullWidth
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <DropdownSelect
          label=''
          placeholder='Select'
          name='scoringType'
          value={scoringTypeValue}
          options={scoringTypeOptions.map((st) => ({
            value: st.id || '',
            label: st.name
          }))}
          onChange={(e) => onScoringTypeChange(e.target.value as string)}
          hasTopLabel={false}
          required
          fullWidth
          loading={isLoadingScoringTypes}
          sx={{ '& h6': { marginBottom: 0 } }}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <TextInputWithIcon
          label='Max Marks'
          placeholder='Enter Max Marks'
          value={maxMarksValue}
          onChange={(e) => onMaxMarksChange(e.target.value)}
          hasTopLabel={false}
          fullWidth
          type='number'
          required={needsMaxMarks}
          disabled={!needsMaxMarks}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <TextInputWithIcon
          label='Order'
          placeholder='Order'
          value={orderValue}
          onChange={(e) => onOrderChange(e.target.value)}
          hasTopLabel={false}
          fullWidth
          type='number'
          required
        />
      </Box>
      <IconButton
        aria-label='delete row'
        onClick={onDeleteRequest}
        size='small'
        sx={{ flexShrink: 0 }}
      >
        <Icons.Delete />
      </IconButton>
    </Box>
  );
};

export default MarkBookSectionRow;
